import { z } from 'zod';
/** Launch values a campaign package can carry from a creation-time default. */
export const campaignDefaultedFieldValues = [
    'dailyBudget',
    'radiusKm',
    'ageRange',
    'destination',
];
const fieldSchema = z.object({ label: z.string(), value: z.string() });
const webUrl = z
    .string()
    .url()
    .refine((value) => /^https?:\/\//i.test(value));
/** Saved references and creatives shown by a launch token's review card. */
export const campaignPackageReviewSchema = z.object({
    offer: z
        .object({
        id: z.string().min(1).optional(),
        title: z.string(),
        fields: z.array(fieldSchema),
    })
        .optional(),
    campaign: z.object({ title: z.string(), fields: z.array(fieldSchema) }),
    ads: z
        .array(z.object({
        adId: z.string(),
        title: z.string(),
        headline: z.string(),
        primaryText: z.string(),
        description: z.string().optional(),
        callToAction: z.string().optional(),
        destinationUrl: z.union([webUrl, z.literal('')]),
        leadForm: z
            .object({ id: z.string().min(1), name: z.string() })
            .optional(),
        media: z.object({
            type: z.enum(['image', 'video']),
            url: webUrl,
            posterUrl: webUrl.optional(),
        }),
    }))
        .min(1)
        .max(20),
    /**
     * Launch values the owner never chose: the tool applied a saved or built-in
     * default when the campaign was created and the value is still unchanged
     * (ENG-1947). The card and Claire name them so the owner can change them.
     */
    defaulted: z.array(z.enum(campaignDefaultedFieldValues)).optional(),
    /**
     * Other campaigns created in the last 24 hours that look like this one, so
     * a near-duplicate is mentioned before launch instead of after (ENG-1947).
     */
    recentSimilarCampaigns: z
        .array(z.object({
        campaignId: z.string(),
        name: z.string(),
        createdAt: z.string(),
        matchReasons: z.array(z.string()),
    }))
        .max(10)
        .optional(),
});
const selectedCardSchema = z.object({
    token: z.string().min(1).max(128),
    toolName: z.string().min(1).max(128),
    // Existing bulk lead cards bind up to 25 IDs into one resource string.
    resourceId: z.string().min(1).max(4096),
});
/**
 * The card selected by this authenticated request, never a model argument.
 *
 * `batch` carries the other cards raised in the same assistant turn when the
 * owner approved them together with one "Approve all" (ENG-1945). Without it
 * a bulk request (a deposit on five services) raised five cards, one click
 * approved one, and the rest came back CONFIRMATION_NOT_SELECTED.
 */
export const confirmationSelectionSchema = selectedCardSchema.extend({
    batch: z.array(selectedCardSchema).max(24).optional(),
});
//# sourceMappingURL=campaign-package.js.map